export function popups() {
	$(document).ready(function () {
		const popupContainer = $('.popup-container')
		if (popupContainer.length > 0) {
			const popupId = popupContainer.data('popup-id')
			const viewedPopups = localStorage.getItem('viewedPopups')
			const showPopup = !viewedPopups || !viewedPopups.includes(popupId)

			if (showPopup) {
				popupContainer.removeClass('popup-container--hidden')
			}

			$('.popup-container__popup__close').click(function (e) {
				e.preventDefault()

				let viewedPopups = localStorage.getItem('viewedPopups')
				viewedPopups += popupId
				localStorage.setItem('viewedPopups', viewedPopups)

				popupContainer.addClass('popup-container--fadeout')

				setTimeout(() => {
					popupContainer.addClass('popup-container--hidden')
				}, 350)
			})
		}
	})

}
